<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 2V19L17 10.5L3 2Z" fill="black"/>
</svg>
